import React, { useState } from 'react';
import IssuesList from '../IssuesList';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';

const ApplicationIssuesList = (props) => {
    const [active, setActive] = useState('1');
    return (
        <React.Fragment>
            <Nav tabs>
                <NavItem>
                    <NavLink
                        active={active === '1'}
                        href="#"
                        onClick={() => {
                            setActive('1');
                        }}>
                        Application
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        active={active === '2'}
                        href="#"
                        onClick={() => {
                            setActive('2');
                        }}>
                        Application Issues
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        active={active === '3'}
                        href="#"
                        onClick={() => {
                            setActive('3');
                        }}>
                        Pentesting Team
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={active}>
                <TabPane tabId="1">
                    <IssuesList listUrl="scan/application/report/list" type="application" />;
                </TabPane>
                <TabPane tabId="2">
                    <IssuesList listUrl="scan/application_issues/report/list" type="application issues" />
                </TabPane>
                <TabPane tabId="3">
                    <IssuesList listUrl="scan/red-team/report/list" type="pentesting team" />
                </TabPane>
            </TabContent>
        </React.Fragment>
    );
};

export default ApplicationIssuesList;
